import { ValueOf } from '../utilities/types';

const thresholdPriorities = {
  GLOBAL_FIRST: 'globalFirst',
  KYC_FIRST: 'kycFirst',
  MOST_RESTRICTIVE: 'mostRestrictive',
  LEAST_RESTRICTIVE: 'leastRestrictive',
} as const;

export type ThresholdPriorities = ValueOf<typeof thresholdPriorities>;

const thresholdLabels: Record<ThresholdPriorities, string> = {
  [thresholdPriorities.GLOBAL_FIRST]: 'Default parameters',
  [thresholdPriorities.KYC_FIRST]: 'KYC form parameters',
  [thresholdPriorities.MOST_RESTRICTIVE]: 'Most restrictive parameters',
  [thresholdPriorities.LEAST_RESTRICTIVE]: 'Least restrictive parameters',
};

export const priorityChoices = [
  thresholdPriorities.MOST_RESTRICTIVE,
  thresholdPriorities.LEAST_RESTRICTIVE,
].map((priority) => ({
  id: priority,
  name: thresholdLabels[priority],
}));

export default thresholdPriorities;
